import { getEnvVar } from 'utils/env';

type GrowthBookEnvConfig = {
  apiHost: string;
  clientKey: string;
};

/**
 * The GrowthBook Proxy, not the GrowthBook API. It serves both the SDK payload
 * fetch and the SSE stream — which is why there is one host here and no
 * separate `streamingHost` — and it is the host every other Mosaic app points
 * its SDK at, so it is the proven path.
 */
const GROWTHBOOK_PROXY_HOST = 'https://growthbook-proxy.prod.us-east4.mosaicapp.com';

/**
 * Galaxy's own GrowthBook SDK connections ("Galaxy Party" / "Galaxy Prod"),
 * scoped to the Mosaic project — one per GrowthBook environment, since a
 * connection serves exactly one environment's evaluated rules.
 *
 * These are public browser SDK keys, shipped in the bundle either way, and
 * every other Mosaic app keeps its key in config rather than a secret store.
 *
 * Environments with no entry (gov) leave the SDK uninitialized, so every flag
 * reads false there.
 */
const CONFIG_BY_UI_ENV: Record<string, GrowthBookEnvConfig> = {
  party: {
    apiHost: GROWTHBOOK_PROXY_HOST,
    clientKey: 'sdk-dUYNgrL9CUI6QBnn',
  },
  prod: {
    apiHost: GROWTHBOOK_PROXY_HOST,
    clientKey: 'sdk-WXpCTF3FDJXAIadG',
  },
};

export const getGrowthBookConfig = (): GrowthBookEnvConfig | undefined =>
  CONFIG_BY_UI_ENV[getEnvVar('UI_ENV') || ''];
